import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

interface SearchBarProps {
  placeholder: string;
  onSearch: (query: string) => void;
  paddingClass?: string;
  fontSizeClass?: string;
}

function SearchBar({
  placeholder,
  onSearch,
  paddingClass,
  fontSizeClass,
}: SearchBarProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  let searchStr = searchParams.get("searchTerm") || "";
  const [searchTerm, setSearchTerm] = useState(searchStr);
  const location = useLocation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  useEffect(() => {
    let isSearchParamAvailable = searchParams.get("searchTerm") ? true : false;

    if (!isSearchParamAvailable && location.pathname === "/") {
      setSearchTerm("");
    }
  }, [location.pathname]);

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        className={`form-control ${paddingClass ? paddingClass : ""} ${
          fontSizeClass ? fontSizeClass : ""
        }`}
        placeholder={placeholder}
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
      />
    </form>
  );
}

export default SearchBar;
